import { ActionService, ReduxService } from 'dashboard-services/services';
import TimeService from 'dashboard-services/services/TimeService';
import { globalActions } from 'primary-components';

export default (() => {
  const AI_TOOLS_FILE_UPLOAD_PREFIX = "AI_TOOLS_FILE_UPLOAD_PREFIX",
        AI_TOOLS_PROMPT_GENERATE_PREFIX = "AI_TOOLS_PROMPT_GENERATE_PREFIX",
        AI_TOOLS_OUTPUT_GENERATE_PREFIX = "AI_TOOLS_OUTPUT_GENERATE_PREFIX"

  const ON_CHANGE = 'ON_CHANGE_AI_TOOLS'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const CLEAR = 'CLEAR_AI_TOOLS'
  const clear = ActionService.makeActionCreator(CLEAR)

  const ADD_TO_VERSIONS = 'ADD_TO_VERSIONS_AI_TOOLS'
  const addToVersions = ActionService.makeActionCreator(ADD_TO_VERSIONS, "item")

  const clearInputFile = () => dispatch => {
    dispatch(onChange(undefined, "inputFile"))
    dispatch(onChange(undefined, "inputFileRaw"))
    dispatch(onChange(undefined, "inputFileInfo"))
  }

  const clearOutputFile = () => dispatch => {
    dispatch(onChange(undefined, "outputFile"))
    dispatch(onChange(undefined, "outputFileRaw"))
    dispatch(onChange(undefined, "outputFileInfo"))
  }

  const handleNewVersionCheck = () => (dispatch, getState) => {
    const { currentVersion, versions, prompt } = getState().aiToolsState.aiToolsCommonState,
          definedTime = getState().myAccountState.settingsState.definedTime

    if(!currentVersion.isPreviousVersion || (currentVersion.isPreviousVersion && prompt !== versions[currentVersion.index - 1]?.prompt)){
      dispatch(addToVersions({ prompt, startTime: TimeService.getUserFormattedDateTime(undefined, definedTime, TimeService.ISO_DATE_TIME_FORMAT_BACKEND_WITH_SECONDS_STYLE) }))
      if(versions?.length > 0){
        dispatch(onChange({
          index: versions?.length + 1,
          isPreviousVersion: false
        }, "currentVersion"))
      }
    }
  }

  const checkIfFileIsThere = ({ fileId, counter = 0, setInfo, fileInfo, timeoutRef, requestId, afterUploadAction, getFileDefinition }) => dispatch => {
    const onErrorAction = () => {
      if(counter === 4){
        return;
      }
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => {
        dispatch(checkIfFileIsThere({ fileId, counter: counter++, setInfo, fileInfo, requestId, afterUploadAction, getFileDefinition }))
      }, 3000)
    }

    return getFileDefinition({ id: fileId })
      .catch(() => onErrorAction())
      .then(res => setInfo(ReduxService.updateObject(fileInfo, { fid: res.fid })))
      .then(infoObj => {
        dispatch(globalActions.handleRequest({ id: requestId, isResponse: true }))
        return infoObj;
      })
      .then(infoObj => afterUploadAction?.(infoObj))
  }

  return {
    onChange,
    ON_CHANGE,
    clear,
    CLEAR,
    addToVersions,
    ADD_TO_VERSIONS,
    clearInputFile,
    clearOutputFile,
    handleNewVersionCheck,
    checkIfFileIsThere,
    AI_TOOLS_FILE_UPLOAD_PREFIX,
    AI_TOOLS_PROMPT_GENERATE_PREFIX,
    AI_TOOLS_OUTPUT_GENERATE_PREFIX
  }
})()